import api from './Api';

function init() {
  if (!this.$api) {
    this.$api = api;
  }
}

export default function install(Vue) {
  Vue.mixin({ beforeCreate: init });
}



// WEBPACK FOOTER //
// ./src/api/index.js